import { fetchData, fetchGetData } from '../../services/apiClient';
import { API_ENDPOINTS } from '../../services/ApiConfig';

export interface OutputOverviewPayload {
  scenarios: string[];
  state: string[];
  bottler: string[];
  select: string;
  view_by: string;
}

export const fetchOutputOverview = async (payload: OutputOverviewPayload): Promise<any[]> => {
  return fetchData<any[]>(API_ENDPOINTS.SCENARIO_OUTPUT.FETCH_SCENARIO_OVERVIEW_DATA, payload);
};

export const fetchLatestScenarios = async (): Promise<string[]> => {
  const response = await fetchGetData<{ scenario_names: string[] }>(
    API_ENDPOINTS.SCENARIO_OUTPUT.FETCH_LATEST_SCENARIOS,
  );
  return response.scenario_names;
};
